export default __webpack_public_path__ + "static/media/arrow_drop_down_white_48dp.209aa8ce.svg";